import { TranslateService } from '@ngx-translate/core';
import type { DutyTemplateItem } from '../models/duty-template.model';
import {
  PREDEFINED_ROUTINES,
  type PredefinedRoutine,
} from '../models/predefined-routine.model';

const DEFAULT_REWARD_XP = 10;

export function findPredefinedRoutine(
  starterId: string,
): PredefinedRoutine | undefined {
  return PREDEFINED_ROUTINES.find((routine) => routine.id === starterId);
}

export function resolvePredefinedRoutine(
  routine: PredefinedRoutine,
  translate: TranslateService,
): { name: string; items: DutyTemplateItem[] } {
  return {
    name: translate.instant(routine.nameKey),
    items: routine.items.map((item) => ({
      title: translate.instant(item.titleKey),
      content: translate.instant(item.contentKey),
      rewardXp: item.rewardXp ?? DEFAULT_REWARD_XP,
      rewardGold: 0,
      recurrenceFrequency: item.recurrenceFrequency ?? 'DAILY',
    })),
  };
}
